<router-outlet></router-outlet>
<app-detail-modal></app-detail-modal>